export default {
    namespaced: true,
    state: {
        contactMomentCategory: null
    },
    getters: {
        contactMomentCategory: (state) => {
            return state.contactMomentCategory;
        },
        findContactMomentCategory: (state) => (contactMomentCategoryId) => {
            for(let index in state.contactMomentCategory) {
                if(state.contactMomentCategory.hasOwnProperty(index)) {
                    if(state.contactMomentCategory[index].id === contactMomentCategoryId) {
                        return state.contactMomentCategory[index];
                    }
                }
            }
            return null;
        }
    },
    actions: {

    },
    mutations: {
        contactMomentCategory (state, contactMomentCategory) {
            state.contactMomentCategory = contactMomentCategory;
        }
    }
}